export const environment = {
    // Set to true to load up videos from the local machine, rather than AWS
    // These videos should be placed in public/videos/ & public/images/ during dev and build/videos & build/images in production.
    localMedia: true
};


// WEBPACK FOOTER //
// ./src/env.js